import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="visibility"
export default class extends Controller {
  static targets = ["element", "input", "value"];
  static values = {
    type: String,
  };

  connect() {
    this.element[this.identifier] = this;
  }

  elementTargetConnected() {
    if (!this.inputTarget.dataset.action) this.inputTarget.dataset.action = "";

    if (!this.hasTypeValue) this.typeValue = this.inputTarget.type;

    this.inputTargets.forEach((element) => {
      if (!element.dataset.action) element.dataset.action = "";
      if (element.dataset.action.indexOf("visibility#update") == -1)
        element.dataset.action += " visibility#update";
    });

    this.update();
  }

  condition(element) {
    let value = element.dataset.visibilityValue;

    if (!value) value = this.data.get("value");

    if (this.typeValue == "checkbox") {
      return this.inputTarget.checked;
    } else if (this.typeValue == "radio") {
      const elements = [
        ...this.element
          .closest("form")
          .querySelectorAll(`input[name="${this.inputTarget.name}"]`),
      ];

      return elements.filter((e) => e.checked && value.indexOf("|" + e.value + "|") > -1).length > 0;
    } else if (this.typeValue == "password" || !value) {
      if (this.data.has("empty")) return this.inputTarget.value == "";
      else return this.inputTarget.value != "";
    } else {
      return value.indexOf("|" + this.inputTarget.value + "|") > -1;
    }
  }

  update() {
    if (!this.hasElementTarget) return;

    this.elementTargets.forEach((element) => {
      let condition = this.condition(element);

      if (element.dataset.visibilityNot) condition = !condition;

      if (this.hasValueTarget && !condition)
        this.valueTarget.tagName == "SELECT"
          ? (this.valueTarget.selectedIndex = 0)
          : (this.valueTarget.value = "");

      element.classList.toggle("!hidden", !condition);
    });
  }
}
